import {cloneElement, useCallback, useState} from 'react';

export const useLightBox = () => {
    const [show, setShow] = useState(false);

    const handle = useCallback((event, show) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        setShow(show);
    }, [setShow]);

    const handleClick = useCallback(event => handle(event, true), [handle]);
    const handleClose = useCallback(event => handle(event, false), [handle]);

    return {show, onClick: handleClick, onClose: handleClose};
};

const Manager = ({children}) => {
    const props = useLightBox();

    return cloneElement(children, props);
};

export default Manager;
